<!-- Titre de la page changement de coordonnées crédit -->
<h1 *ngIf="!isAppMobile" tabindex="-1" class="dsd-t-3">{{ titrePageCoordonneesCredit | translate }}</h1>
<ng-container
  *ngIf="afficherPageAucuneCarteCredit; then afficherPageAucuneCarte; else afficherPageAccueil"></ng-container>
<ng-template #afficherPageAccueil>
  <div *ngIf="reponseCoordonneesCredit">
    <!-- Alerte information-->
    <dsd-alert variant="information" tabindex="-1">
      <h2 slot="title">{{ 'caad.accueil.alerte.horsEcran.information' | translate }}</h2>
      <p [innerHtml]="messageAlerte | translate"></p>
    </dsd-alert>
    <!-- Section carte de crédit liées au compte -->
    <dsd-container class="container-carte">
      <h2 class="dsd-t-4 dsd-mb-md">
        {{ titreSectionCarteCredit | translate }}
      </h2>
      <dsd-reveal-items [show]="3" type="all" selector="dsd-grid-col">
        <span slot="label">{{ 'caad.accueil.libelle.carte' | translate }}</span>
        <div slot="items">
          <dsd-grid-row>
            <dsd-grid-col
              class="dsd-mb-md"
              *ngFor="let particulierCredit of reponseCoordonneesCredit.particulierCredit"
              sm-col="12"
              md-col="6"
              lg-col="4">
              <app-info-carte [infoCarte]="particulierCredit.carte"></app-info-carte>
            </dsd-grid-col>
          </dsd-grid-row>
        </div>
      </dsd-reveal-items>
    </dsd-container>
    <!-- Section coordonnées liées au compte -->
    <dsd-container>
      <h2 class="dsd-t-4 dsd-mb-md">
        {{ 'caad.accueil.titreServiceCarteCredit' | translate }}
      </h2>
      <!-- Adresse postale -->
      <p>
        <span class="libelle-credit">{{ 'caad.accueil.libelle.adressePrincipale' | translate }}&nbsp;</span>
        <span class="valeur line-adresse dsd-mb-0">{{ adressePostale | adresse }}</span>
      </p>
      <!-- Téléphone principal -->
      <p>
        <span class="libelle-credit">{{ 'caad.accueil.libelle.telephone' | translate }}&nbsp;</span>
        <span *ngIf="!affichageAucunTelephonePrincipal" class="valeur dsd-mb-0">{{ telephonePrincipal | phone }}</span>
        <span *ngIf="affichageAucunTelephonePrincipal" class="valeur dsd-mb-0">{{
          'caad.accueil.libelle.telephoneVide' | translate
        }}</span>
      </p>
      <!-- Adresse courriel -->
      <ng-container
        *ngIf="
          affichageAucuneAdresseCourriel;
          then affichageAucunCourriel;
          else affichageAdresseCourriel
        "></ng-container>
      <ng-template #affichageAucunCourriel>
        <p class="dsd-mb-0">
          <span class="libelle-credit">{{ 'caad.accueil.libelle.adresseCourriel' | translate }}&nbsp;</span>
          <span class="valeur">{{ 'caad.accueil.libelle.adresseCourrielVide' | translate }}</span>
        </p>
      </ng-template>

      <ng-template #affichageAdresseCourriel>
        <ng-container
          *ngIf="!particuliersCreditPlusQueUn || affichageAdresseCourrielIdentique; else affichageMultipleCourriels">
          <p class="dsd-mb-0">
            <span class="libelle-credit">{{ 'caad.accueil.libelle.adresseCourriel' | translate }}&nbsp;</span>
            <span class="valeur">
              {{ courrielUnique }}
            </span>
          </p>
        </ng-container>
        <ng-template #affichageMultipleCourriels>
          <ng-container *ngFor="let particulierCredit of reponseCoordonneesCredit.particulierCredit">
            <p class="dsd-mb-0">
              <span class="libelle-credit">
                {{ 'caad.accueil.libelle.adresseCourrielDeLaCarte' | translate }}&nbsp;{{
                  particulierCredit.carte.descriptionCourte
                }}&nbsp;
              </span>
              <span class="valeur line-adresse dsd-mb-md">{{
                particulierCredit.adresseCourriel?.adresseCourriel
              }}</span>
            </p>
          </ng-container>
        </ng-template>
      </ng-template>
    </dsd-container>
    <div class="zone-btn">
      <!-- Bouton Modifier -->
      <dsd-button (dsdButtonClick)="clicSurModifier()" variant="primary" full-width="xs">
        {{ 'caad.button.modifier' | translate }}
        <span class="dsd-sr-only"> {{ 'caad.accueil.libelle.horsEcran.modifierCoordonnees' | translate }}</span>
      </dsd-button>

      <!-- Bouton Précédent -->
      <dsd-button (dsdButtonClick)="allerVersPrecedent()" full-width="xs">
        {{ 'caad.button.precedent' | translate }}
      </dsd-button>
    </div>
  </div>
  <div *ngIf="!estBancaireActif()" class="dsd-mt-md dsd-mb-md">
    <app-bouton-retour></app-bouton-retour>
  </div>
</ng-template>
<ng-template #afficherPageAucuneCarte>
  <div>
    <dsd-container>
      <h2 class="dsd-t-4" tabindex="-1">{{ 'caad.accueil.erreur.carte.titre' | translate }}</h2>
      <p class="dsd-mb-0">
        {{ 'caad.accueil.messageAucuneCarteCreditFiserv' | translate }}
        <dsd-link
          ><a href="https://www.desjardins.com/particuliers/prets-marges-cartes-credit/cartes-credit/index.jsp">
            {{ 'caad.accueil.erreur.carte.lien' | translate }}
          </a></dsd-link
        >.
      </p>
    </dsd-container>
  </div>
  <app-bouton-retour *ngIf="!estBancaireActif()"></app-bouton-retour>
</ng-template>
